/** Ключ localStorage для темы интерфейса (синхронно с `createVuetify` в main.ts). */
export const PRICE_UI_THEME_KEY = 'price-ui-theme';

export type PriceUiThemeName = 'light' | 'dark';

export function readStoredUiTheme(): PriceUiThemeName {
    try {
        const v = localStorage.getItem(PRICE_UI_THEME_KEY);
        if (v === 'dark' || v === 'light') {
            return v;
        }
    } catch {
        /* private mode / недоступное хранилище */
    }
    return 'light';
}
